export default "__VITE_ASSET__CN3Q$CWV__"